@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.alerts-list-page {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.grid-header {
  display: flex;
  background-color: @alert-list-page--grid-header--background-color;
  justify-content: space-between;
}

.grid {
  flex-grow: 1;
  width: 100%;
  height: calc(100% ~'-' 42px);
  overflow: auto;
  background-color: @alert-list-page--grid--background-color;
}

.paging-footer {
  min-height: 42px;
  border-top: 1px solid @alert-list-page--paging-footer--border-color;
}

.actions-section {
  display: flex;
  background-color: @alert-list-page--actions-section--background-color;
  padding-left: 5px;
  > div {
    margin-left: 10px;
  }
}

.alert-supplemental {
  padding: 15px 0;
  font-size: 15px;
  color: @alert-list-page--alert-supplemental--text-color;
}
